import React from "react";
import styled from "@emotion/styled";
import { media } from "../tokens";

const Close = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
  ${media.medium} {
    right: 32px;
    top: 32px;
  }

  :hover {
    cursor: pointer;
    opacity: .5;
    transition: opacity .2s;
  }
  :before,
  :after {
    position: absolute;
    left: 15px;
    content: " ";
    height: 33px;
    width: 2px;
    background-color: #2d2d2d;
  }
  :before {
    transform: rotate(45deg);
  }
  :after {
    transform: rotate(-45deg);
  }
`;

const CloseButton = () => {

  const handleClose = () => {
    let leaveApp = confirm("Are you sure you want to exit? You'll be returned to the Oslin Nation homepage.")
    if ( leaveApp ) {
      window.location = 'https://onco-tx.com/';
    }
  };

  return (
    <div>
      <Close onClick={handleClose} />
    </div>
  );
}

export default CloseButton;
